import React, { useEffect } from "react";
import { Outlet, Route, Routes, useParams } from "react-router-dom";
import Heading from "../Component/Heading";
import ImgComp from "../Component/ImgComp";
import axios from "axios";
import HomeContent from "../Modules/HomeContent";
import { useState } from "react";
import NotFound from "./NotFound";
import StartPage from "./StartPage";
import PaymentPage from "./PaymentPage";
import ThankPage from "./ThankPage";
import { useDispatch, useSelector } from "react-redux";
import { resetState } from "../Component/Redux/Feature/UrlSlice";
import HomeContentNew from "../Modules/HomeContentNew";
import { getAllCategoriesThunk } from "../Component/Redux/Feature/CategorySlice";
// import { resetState } from "../Component/Redux/Feature/UrlSlice";
// import "../../public/asset/CSS/Modules/all.scss";
import categoriesData from "../data/categories.json";
import { adminapiUrl } from "../Utils/constants";

const Home = (props) => {
  
  const [categorySlug, setCategorySlug] = useState(null);
  const [categories, setCategories] = useState(null);
  const { category } = useParams();

  const [categoriesMap, setCategoriesMap]  = useState({});


  const dispatch = useDispatch();

  
  // useEffect(() => {
  //   dispatch(resetState());
  // }, []);
  
  useEffect(() => {
    // const queryParams = new URLq(window.location.search);

    // console.log("query_params => ", queryParams)

    // const catSlug = queryParams.get("category")

    if(category) setCategorySlug(category)
    
      console.log("Cat slug --->", category)

      const getCategories = async () => {
        const res = await axios.get(
          adminapiUrl+"/read_allbranch_alltypes_allplans",
          // "https://admin-api.bodyprocoach.com/admin/read_allbranch_alltypes_allplans",
          {
            headers: {
              "Content-Type": "application/json",
            },
            mode: "no-cors",
          }
        );
    
        const data = res.data.data;
        setCategories(data?.All_categories);
        if(data?.All_categories) {
          const cat_slug_map = {}
          data?.All_categories.map((cat, index) => {
            if(index < 3){ 
              cat_slug_map[cat.slug] = 'sweat'
              console.log("BLUE --> ", cat_slug_map[cat.slug])
              
             }
            else { 
              cat_slug_map[cat.slug] = 'bootcamp' 
              console.log("RED --> ",cat_slug_map[cat.slug])
              console.log("changing global theme style #e6001e", document?.documentElement?.style );
            }
          })

          console.log("CAT SLUG MAP --> ", cat_slug_map)
          setCategoriesMap(cat_slug_map);
        }

        console.log("categories in sessions => ", data);
      };
      getCategories();

  }, [category]);

  useEffect(() => {
    if(categoriesMap && categorySlug) {
    if(categoriesMap[categorySlug] == "bootcamp") document.documentElement.style.setProperty('--global-theme', 'black');
    else if(categoriesMap[categorySlug] == "sweat") document.documentElement.style.setProperty('--global-theme', 'black');
    }
  }, [categorySlug, categoriesMap])
 
  return (
    <>
      <div className="home-page">
        {categoriesMap[categorySlug] && (
          <>
        <ImgComp appname = {categories?.find(cat => cat?.slug == categorySlug)?.uid == 10 ? "bootcamp" : "sweat"} />
        <HomeContentNew  appname = {categories?.find(cat => cat?.slug == categorySlug)?.uid == 10 ? "bootcamp" : "sweat"} />
        </>
        )}
      </div>
    </>
  );
};

export default Home;
